import { Form, FormProps, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface ServiceOrderAdminDataProps {
  formProps?: FormProps;
}

const ServiceOrderAdminData = (props: ServiceOrderAdminDataProps) => {
  const { t } = useTranslation();
  const { formProps } = props;
  // Mapea el valor persistido (string separado por comas) a valores editables en UI.
  const technicianPay = Form.useWatch('technician_pay', formProps?.form);
  const billingNumbersToList = (value?: string | string[]) => {
    if (!value) return [];
    if (Array.isArray(value)) return value.filter(v => v && v.trim().length > 0);

    return value
      .split(',')
      .map(v => v.trim())
      .filter(Boolean);
  };

  // Convierte el listado editable del input a un string separado por comas para guardar en backend.
  const billingNumbersToString = (value?: string[]) =>
    (value ?? [])
      .map(v => v.trim())
      .filter(Boolean)
      .join(',');

  return (
    <>
      <div className="ServiceOrderFormRow">
        <Form.Item
          label={t('Horas informadas por técnico')}
          name={'hours'}
          rules={[
            {
              required: true,
              message: t('Las {{field}} son obligatorias', {
                field: t('horas informadas'),
              }),
            },
          ]}>
          <Input suffix="hs" />
        </Form.Item>
        <Form.Item
          label={t('Kilómetros informados por técnico')}
          name={'kilometres'}
          rules={[
            {
              required: true,
              message: t('Los {{field}} son obligatorios', {
                field: t('kilómetros informados'),
              }),
            },
          ]}>
          <Input suffix="km" />
        </Form.Item>
      </div>
      <div className="ServiceOrderFormRow">
        <Form.Item
          label={t('Horas a pagar')}
          name={'hours_to_pay'}
          rules={[
            {
              required: true,
              message: t('Las {{field}} son obligatorias', {
                field: t('horas informadas'),
              }),
            },
          ]}>
          <Input suffix="hs" />
        </Form.Item>
        <Form.Item
          label={t('Kilómetros a pagar')}
          name={'kilometres_to_pay'}
          rules={[
            {
              required: true,
              message: t('Los {{field}} son obligatorios', {
                field: t('kilómetros informados'),
              }),
            },
          ]}>
          <Input suffix="km" />
        </Form.Item>
        <Form.Item
          label={t('Números de factura')}
          name={'billing_numbers'}
          rules={[
            {
              required: technicianPay ? true : false,
              message: t('Los {{field}} son obligatorios', {
                field: t('números de factura'),
              }),
            },
          ]}
          getValueProps={value => ({
            value: billingNumbersToList(value),
          })}
          getValueFromEvent={(value: string[]) => billingNumbersToString(value)}>
          <Select
            mode="tags"
            tokenSeparators={[',']}
            placeholder={t('Ingrese uno o más números de factura')}
          />
        </Form.Item>
      </div>
    </>
  );
};

export default ServiceOrderAdminData;
